import {forwardRef} from 'react';
import TextareaAutosize, {TextareaAutosizeProps} from 'react-textarea-autosize';
import cx from 'classnames';

import {inputStyles, rootStyles} from '#component/base/TextInput/TextInput.css';
import {TextInputProps} from '#component/base/TextInput/TextInput.types';
import {sprinkles} from '#style/sprinkles';

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({children, className, disabled = false, error = false, maxRows = 8, ...otherProps}, ref?) => {
    return (
      // Wrap the textarea in a div to keep styling consistent with the TextInput component
      <div className={cx(rootStyles({disabled, error}), className)}>
        <TextareaAutosize
          className={cx(inputStyles, sprinkles({resize: 'none'}))}
          aria-invalid={error}
          disabled={disabled}
          ref={ref}
          maxRows={maxRows}
          {...otherProps}
        />
      </div>
    );
  },
);

export type TextAreaProps = TextareaAutosizeProps &
  Pick<TextInputProps<'input'>, 'disabled' | 'error' | 'id' | 'placeholder'>;
